import { type IProject } from "@/interfaces/api/project.interface"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { type RentalIntake } from "@/models/rental-intake.model"
import { ModelFactory } from "@/factories/model-factory"
import { BaseModelWithFiles, WithExtraFileBuckets } from "@/models/base-with-files.model"

export class Project
  extends WithExtraFileBuckets("fileBucketServiceProviderAttachments")(BaseModelWithFiles)
  implements IProject
{
  public static className = "Project" // Used for socket communication.
  public static verboseName = "project"

  public static managedResolveFields = ["executor", "contact"]

  id?: string

  executor: KnownBusinessEntityContact

  contact: KnownBusinessEntityContact

  name: string

  descriptionPlanner?: string

  descriptionServiceProvider?: string

  rentalIntakes: RentalIntake[]

  constructor(project: IProject, managed = false) {
    super(project, managed)

    this.id = project.id
    this.executor = ModelFactory.childModel(KnownBusinessEntityContact, project.executor, managed)
    this.contact = ModelFactory.childModel(KnownBusinessEntityContact, project.contact, managed)

    this.name = project.name
    this.descriptionPlanner = project.descriptionPlanner
    this.descriptionServiceProvider = project.descriptionServiceProvider

    this.rentalIntakes = []
  }

  public getDisplayText(): string {
    return `${this.name} | ${this.executor.person.fullName} | ${this.executor.knownBusinessEntityName}`
  }

  public getDisplayArray(): [string, string, string] {
    return [
      `${this.name}`,
      `${this.executor.person.fullName}`,
      `${this.executor.knownBusinessEntityName}`
    ]
  }

  /** Label for @-mentions: project name plus financieel verantwoordelijke's business. */
  public getMentionLabel(): string {
    const businessName = this.executor?.knownBusinessEntityName?.trim()
    if (businessName && businessName !== "Onbekend") {
      return `${this.name} | ${businessName}`
    }
    return this.name
  }
}
